<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
      <div v-if="type != 'add'">
        <span>果园编号：</span>
        <span>{{ form.bizNo }}</span>
      </div>
    </div>

    <el-form ref="form" :rules="rules" :model="form" label-width="80px" label-position="right">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="果园名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="产品名称" prop="cropBrandKey">
            <el-select v-model="form.cropBrandKey" filterable placeholder="请选择">
              <el-option
                v-for="item in productList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item label="果园区域" prop="villageCode">
            <div class="flex">
              <area-select
                v-if="isInitArea"
                v-model="selectedArea"
                :data="$pcaa"
                :level="3"
                @change="handleArea"
              ></area-select>
              <span class="left">
                <el-select
                  v-model="form.villageCode"
                  placeholder="请选择村"
                  @change="getFieldList"
                  filterable
                  remote
                  :remote-method="remoteMethod"
                >
                  <el-option
                    v-for="item in villageList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </span>
              <span class="left fieldCode">
                <el-select
                  v-model="form.fieldCode"
                  clearable
                  filterable
                  placeholder="请选择围"
                  remote
                  :remote-method="fieldremoteMethod"
                >
                  <el-option
                    v-for="item in fieldList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="土地性质">
            <el-select
              v-model="form.fieldTypeKeyList"
              multiple
              filterable
              placeholder="请选择"
              :ref="'cascader'"
              @visible-change="(v) => visibleChange(v, 'cascader', cascaderClick)"
            >
              <el-option
                v-for="item in landList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="果园亩数">
            <!-- "value=value.replace(/\D/g,'')" -->
            <el-input
              v-model="form.occupiedArea"
              oninput="value=value.replace(/[^\d.]/g,'').replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3')"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item label="园主/场长">
            <el-input v-model="form.ownerName" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item label="联系方式">
            <el-input
              v-model="form.ownerContact"
              oninput="value=value.replace(/[^\d-]/g,'')"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item label="备注">
            <el-input
              type="textarea"
              :rows="3"
              maxlength="300"
              v-model="form.remark"
              placeholder="300字以内"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { modifyPlant, getVillagesOrFields } from '@/api/system/manage'
export default {
  props: {
    type: {
      type: String,
      default() {
        return ''
      },
    },
  },
  data() {
    return {
      fieldList: [],
      villageList: [],
      form: {
        id: '',
        name: '',
        bizNo: '',
        fieldCode: '',
        provinceCode: '440000',
        cityCode: '440700',
        districtCode: '440705',
        streetCode: '440705001',
        villageCode: '',
        cropBrandKey: '',
        fieldTypeKeyList: '',
        occupiedArea: '',
        ownerName: '',
        ownerContact: '',
        remark: '',
      },
      rules: {
        name: [{ required: true, message: '请输入果园名称', trigger: 'blur' }],
        cropBrandKey: [{ required: true, message: '请选择产品名称', trigger: ['blur', 'change'] }],
        villageCode: [{ required: true, message: '请选择果园区域', trigger: ['blur'] }],
      },
      selectedArea: [], //默认广东江门新会会城街道
      isInitArea: false,
    }
  },
  computed: {
    ...mapState({
      landList: (state) => (state.system.dictList && state.system.dictList.landStatus) || [],
      productList: (state) => (state.system.dictList && state.system.dictList.productType) || [],
    }),
  },
  watch:{
    productList: {
      handler(val) {
        if(this.type == 'add'){
          this.form.cropBrandKey = val[0].dictValue
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async initArea(row) {
      let data = row || this.form
      this.selectedArea = [data.provinceCode, data.cityCode, data.districtCode, data.streetCode]
      this.$nextTick(() => {
        this.isInitArea = true
      })
      await this.getVillageList(data.streetCode)
      row.villageCode && (await this.getFieldList(row.villageCode))
    },
    async handleArea(n) {
      if (n && n[3] != this.form.streetCode) {
        this.form.provinceCode = n[0]
        this.form.cityCode = n[1]
        this.form.districtCode = n[2]
        this.form.streetCode = n[3]
        this.form.villageCode = ''
        this.form.fieldCode = ''
        this.villageList = []
        this.fieldList = []
        await this.getVillageList(n[3])
      }
    },
    async getDetails(row) {
      if (row) {
        await this.initArea(row)
        this.form = Object.assign(this.form, {
          ...row,
          fieldTypeKeyList: row.fieldTypeKeyList ? row.fieldTypeKeyList.split(',') : '',
        })
        // row.villageCode && await this.getFieldList(row.villageCode)
      }
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            const provinceText = this.codeToText('area', this.form.provinceCode, '86')
            const cityText = this.codeToText('area', this.form.cityCode, this.form.provinceCode)
            const districtText = this.codeToText('area', this.form.districtCode, this.form.cityCode)
            const streetText = this.codeToText('area', this.form.streetCode, this.form.districtCode)
            const villageText = this.codeToText('village', this.form.villageCode)
            const fieldText = this.codeToText('field', this.form.fieldCode)
            let locDetails = ''
            if (fieldText) {
              locDetails = [provinceText, cityText, districtText, streetText, villageText, fieldText].join(',')
            } else {
              locDetails = [provinceText, cityText, districtText, streetText, villageText].join(',')
            }

            const formData = Object.assign(this.deepClone(this.form), {
              fieldTypeKeyList: this.form.fieldTypeKeyList && this.form.fieldTypeKeyList.join(','),
              locDetails,
            })

            let result = await modifyPlant(formData, this.type)
            if (result.code == 200 && result.flag) {
              this.$message.success(`${this.type == 'edit' ? '修改' : '提交'}成功`)
              resolve()
            } else {
              this.$message.error(result.message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    async remoteMethod(name) {
      await getVillagesOrFields({
        parentCode: this.selectedArea[4],
        level: 6,
        pageNo: 1,
        pageSize: 30,
        name: name,
      }).then((res) => {
        if (res.flag) {
          this.villageList = res.data.items
        }
      })
    },
    async getVillageList(streetCode) {
      await getVillagesOrFields({ parentCode: streetCode, level: 6, pageNo: 1, pageSize: 30 }).then((res) => {
        if (res.flag) {
          this.villageList = res.data.items
        }
      })
    },

    async fieldremoteMethod(name) {
      await getVillagesOrFields({ parentCode: this.form.villageCode, level: 7, name: name }).then((res) => {
        if (res.flag) {
          this.fieldList = res.data.items
          if (!this.fieldList.length) {
            this.form.fieldCode = ''
          }
        }
      })
    },
    async getFieldList(villageCode) {
      if (!villageCode) {
        return
      }
      this.resetField('form', 'villageCode')
      await getVillagesOrFields({ parentCode: villageCode, level: 7 }).then((res) => {
        if (res.flag) {
          this.fieldList = res.data.items
          if (!this.fieldList.length) {
            this.form.fieldCode = ''
          }
        }
      })
    },
    codeToText(fieldName, code, parentCode) {
      let name = ''
      switch (fieldName) {
        case 'area':
          for (let keyCode in this.$pcaa[parentCode]) {
            if (code == keyCode) {
              name = this.$pcaa[parentCode][keyCode]
              break
            }
          }
          return name
        case 'village':
          for (let i = 0; i < this.villageList.length; i++) {
            if (code == this.villageList[i].code) {
              name = this.villageList[i].name
              break
            }
          }
          return name
        case 'field':
          for (let i = 0; i < this.fieldList.length; i++) {
            if (code == this.fieldList[i].code) {
              name = this.fieldList[i].name
              break
            }
          }
          return name
      }
    },
    reset() {
      // this.form = {
      //   id: '',
      //   name: '',
      //   bizNo: '',
      //   cropBrandKey: '',
      //   provinceCode: '440000',
      //   cityCode: '440700',
      //   districtCode: '440705',
      //   streetCode: '440705001',
      //   villageCode: '',
      //   fieldCode: '',
      //   fieldTypeKeyList: [],
      //   occupiedArea: '',
      //   ownerName: '',
      //   ownerContact: '',
      //   remark: '',
      // }
      // this.isInitArea = false
      // this.resetForm('form')
    },
    visibleChange(visible, refName, onClick) {
      if (visible) {
        const ref = this.$refs[refName]
        let popper = ref.$refs.popper
        if (popper.$el) popper = popper.$el
        if (!Array.from(popper.children).some((v) => v.className === 'el-cascader-menu__list')) {
          const landName = this.landList.map((v) => v.dictLabel).join('+')
          const el = document.createElement('ul')
          el.className = 'el-cascader-menu__list'
          el.innerHTML = `<li class="el-cascader-node">${landName}</li>`
          popper.appendChild(el)
          el.onclick = () => {
            // 底部按钮的点击事件 点击后想触发的逻辑也可以直接写在这
            onClick && onClick()
            // 以下代码实现点击后弹层隐藏 不需要可以删掉
            if (ref.toggleDropDownVisible) {
              ref.toggleDropDownVisible(false)
            } else {
              ref.visible = false
            }
          }
        }
      }
    },
    cascaderClick() {
      this.form.fieldTypeKeyList = this.landList.map((v) => v.dictValue)
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item.is-error .fieldCode .el-input__inner,
.el-form-item.is-error .fieldCode .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}
.left {
  margin-left: 10px;
}
/deep/ .area-select.medium {
  height: 39px;
}
/deep/ .area-select-wrap {
  display: flex;
  width: 60%;
}
/deep/ .area-select .area-selected-trigger {
  padding: 0 0 0 10px;
}
.flex {
  display: flex;
}
.area-select {
  height: 38px;
}
</style>